import { ReactElement, useState } from 'react';
import { RoleAttributes } from '../constants/telosair-interfaces';
import AccessColorBlock from './AccessColorBlock';

type RolesSectionProps = {
  data: RoleAttributes;
};

/**
 * React component to render section isnide roles tab.
 * @param props - Properties of RoleSection component.
 * @returns - React component for RolesSections.
 */
export default function RoleSection(props: RolesSectionProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data } = props;
  const [expanded, setExpanded] = useState(true);
  return (
    <tbody className="bg-container-900 divide-y divide-gray-900">
      <tr>
        <td className="bg-container-500 px-6 py-8" colSpan={4}>
          <div className="flex items-center gap-2">
            <div className="text-gray-300 text-sm">{data.type}</div>
            <div className="material-icons-outlined text-base leading-4 text-gray-400 dark:text-gray-500">
              info
            </div>
            <button
              type="button"
              onClick={() => setExpanded((exp) => !exp)}
              className="material-icons-outlined text-lg text-white"
            >
              {expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            </button>
          </div>
        </td>
      </tr>
      {expanded &&
        data.data.map((item) => (
          <tr key={item.type + data.type} className="divide-x divide-gray-900 text-gray-400">
            <td className="p-6 text-start">{item.type}</td>
            <td className="py-3 text-center">
              <AccessColorBlock accessLevel={item.permissions.owner} />
            </td>
            <td className="py-3 text-center">
              <AccessColorBlock accessLevel={item.permissions.operator} />
            </td>
            <td className="py-3 text-center">
              <AccessColorBlock accessLevel={item.permissions.observer} />
            </td>
          </tr>
        ))}
    </tbody>
  );
}
